import * as React from 'react'
import {useEffect, useState} from "react";

import TextField from "@material-ui/core/TextField";
import FlagIcon from "./FlagIcon";
import CloseIcon from "@material-ui/icons/Close";

export const EditableNumberPlate = ({id, value, country, onChange}) => {

    const [edit, setEdit] = useState(false);
    const [currentValue, setCurrentValue] = useState(value);

    const handleKeyPress = (e) => {
        if (e.keyCode == 13 && currentValue.length > 0) {
            // try to save
            setEdit(false);
            onChange({ id: id, oldValue: value, newValue: e.target.value});
        } else if (e.keyCode == 27) {
            handleCancel();
        }
    }

    const handleCancel = () => {

        setCurrentValue(value);
        setEdit(false);
    }

    useEffect(() => {
        setCurrentValue(value);
    }, [value]);

    return (
        <>
        {edit &&  <><TextField autoFocus={true} value={currentValue} onKeyUp={handleKeyPress} onChange={e => setCurrentValue(e.target.value)} /><CloseIcon onClick={handleCancel} fontSize={"small"} /></> }
        {!edit && <span onDoubleClick={e => setEdit(true)}>{currentValue} <FlagIcon code={country} size={"lg"}/></span>}
        </>
        );
}
